export default __webpack_public_path__ + "static/rotary-bae4a156f5ee6cf70618a09a428855f4.jpeg";